import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EventTypes } from 'types/events'
import Input, { YesNoTriggers } from 'components/Input'
import Submit from 'components/fields/Submit'
import ScheduledAt from 'components/ScheduledAt'
import Margin from 'components/Margin'
import { PassengerSelect, LuggageSelect } from 'components/Select'
import useFieldValue from 'hooks/utils/useFieldValue'
import { useUrgentlyProvider } from 'hooks/urgent.ly'
import { isRequired } from 'utils/validators'
import { UnattendedTow } from '../../NoExchange/Steps'
import { CallTypes } from 'types/callstore'
import { useSelector } from 'react-redux'
import { selectFormsState } from 'redux/appStore'
import { BreakdownNote } from 'forms/CallForm/BreakdownDetails'
import { useCreateTowDispatchService } from 'hooks/dispatch/useTowDispatch'
import { useGetProviderCounts } from 'hooks/universalPayload/useGetProviderCounts'

const DispatchTow = () => {
  const { t } = useTranslation()
  const { towExchange } = useSelector(selectFormsState) as any
  const { shouldUseUrgently, isThirdParty } = useUrgentlyProvider()
  const { providerCount, providersLoading: loading } = useGetProviderCounts()
  const [providersLoading, setProvidersLoading] = useState<boolean>(false)
  const customerWithVehicle = useFieldValue('customerWithVehicle') as YesNoTriggers
  const disabledVehiclePickup = useFieldValue('disabledVehiclePickup') as boolean
  const unattendedTow = customerWithVehicle === YesNoTriggers.NO
  const createTowDispatchService = useCreateTowDispatchService(EventTypes.EXCHANGE, providerCount)

  useEffect(() => {
    if (loading) setProvidersLoading(true)
    else setProvidersLoading(false)
  }, [loading])

  return (
    <>
      {unattendedTow && (
        <>
          <UnattendedTow />
          {disabledVehiclePickup && (
            <>
              <BreakdownNote
                breakdownOption={towExchange?.breakdownOption}
                unsafe={towExchange?.unsafe}
                garageAccessible={towExchange?.garageAccessible}
                accessible={towExchange?.accessible}
              />
              <Input.Textarea
                label={`${t('notesToProvider.branch')}*`}
                placeholder={t('notesToProvider.placeholder')}
                maxLength={240}
                name="dispatchRentalNotes"
                validate={isRequired('Provider notes are required')}
              />
            </>
          )}
        </>
      )}
      <Margin spacing="md">
        <ScheduledAt callType={CallTypes.TOW} />
        <Input.Hidden name="scheduledAt" />
      </Margin>
      {shouldUseUrgently && (
        <>
          {isThirdParty && (
            <>
              <Margin spacing="md">
                <PassengerSelect
                  name="passengerCount"
                  label={t('labels.passengerCount')}
                  validate={isRequired('Passenger count is required')}
                />
              </Margin>
              <Margin spacing="md">
                <LuggageSelect
                  name="luggageCount"
                  label={t('labels.luggageCount')}
                  validate={isRequired('Luggage count is required')}
                />
              </Margin>
            </>
          )}
        </>
      )}
      <BreakdownNote
        breakdownOption={towExchange?.breakdownOption}
        unsafe={towExchange?.unsafe}
        garageAccessible={towExchange?.garageAccessible}
        accessible={towExchange?.accessible}
      />
      <Input.Textarea
        label={unattendedTow && disabledVehiclePickup ? `${t('notesToProvider.vehicle')}*` : `${t('notesToProvider.label')}*`}
        placeholder={t('notesToProvider.placeholder')}
        maxLength={240}
        name="notes"
        validate={isRequired('Provider notes are required')}
      />
      <Margin spacing="md">
        <Submit externalLoading={providersLoading} onSubmit={createTowDispatchService}>
          {t('tow.dispatch')}
        </Submit>
      </Margin>
    </>
  )
}

export default DispatchTow
